export type Position = 'top' | 'center' | 'bottom';

const ALIGN_ITEMS_BY_POSITION: Record<Position, string> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

const TRANSFORM_ORIGIN_BY_POSITION: Record<Position, string> = {
  top: '50% 0',
  center: '50% 50%',
  bottom: '50% 100%'
};

export function getAlignItemsByPosition(position: Position = 'center'): string {
  return ALIGN_ITEMS_BY_POSITION[position];
}

export function getTransformOriginByPosition(
  position: Position = 'center'
): string {
  return TRANSFORM_ORIGIN_BY_POSITION[position];
}
